export default __webpack_public_path__ + "static/media/Adopt_App_Oct_2019.b25a3537.doc";